module.exports = __webpack_public_path__ + "static/media/glanum_keltisch.55202500.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_keltisch.png
// module id = 715
// module chunks = 0